

import React from "react";
import style from "./DataQualityRow.module.scss";

export interface ChartDataItem {
  chartType: string;
  failedPercentage: number; // used as count (or percentage value)
  passedPercentage: number; // used as count (or percentage value)
  noRecordPercentage: number;
}

interface DataQualityRowProps {
  data: ChartDataItem;
  tableData: any[];
  setFilteredTableData: React.Dispatch<React.SetStateAction<any[]>>;
  setIsChartSelected: React.Dispatch<React.SetStateAction<boolean>>;
  dataVaultPage?: boolean;
}

const DataQualityRow: React.FC<DataQualityRowProps> = ({
  data,
  tableData,
  setFilteredTableData,
  setIsChartSelected,
  dataVaultPage,
}) => {
  const { chartType, failedPercentage, passedPercentage } = data;

  // Click handler for filtering based on PASSED/FAILED status.
  const handleClick = (status: "PASSED" | "FAILED") => {
    let filteredData: any[] = [];
    if (dataVaultPage !== undefined) {
      if (dataVaultPage) {
        filteredData = tableData.filter(
          (item: any) =>
            item.data_vault_ensemble === chartType &&
            item.data_vault_test_passed === status
        );
      } else {
        filteredData = tableData.filter(
          (item: any) =>
            item.data_mart_table_1 === chartType &&
            item.data_mart_test_passed === status
        );
      }
      setFilteredTableData(filteredData);
      setIsChartSelected(true);
    }
  };

  // Calculate total count; if both are zero, display "No Data"
  const total = passedPercentage + failedPercentage;

  // Calculate each segment's width based on the count.
  // If one of them is zero, the remaining one will naturally have 100%.
  const passedWidth = total ? (passedPercentage / total) * 100 : 0;
  const failedWidth = total ? (failedPercentage / total) * 100 : 0;

  return (
    <div className={style.dataQualityRow}>
      <div className={style.typeColumn} title={chartType}>
        {chartType}
      </div>
      <div className={style.statusColumn}>
        {total > 0 ? (
          <div className={style.barContainer}>
            {failedPercentage > 0 && (
              <button
                type="button"
                className={`${style.statusBar} ${style.failedBar}`}
                style={{ width: `${failedWidth}%` }}
                onClick={() => handleClick("FAILED")}
                title={`Failed ${failedPercentage}`}
              >
                Failed {failedPercentage}
              </button>
            )}
            {passedPercentage > 0 && (
              <button
                type="button"
                className={`${style.statusBar} ${style.passedBar}`}
                style={{ width: `${passedWidth}%` }}
                onClick={() => handleClick("PASSED")}
                title={`Succeeded ${passedPercentage}`}
              >
                Succeeded {passedPercentage}
              </button>
            )}
          </div>
        ) : (
          <div className={style.noData}>No Data</div>
        )}
      </div>
    </div>
  );
};

export default DataQualityRow;
